import {faBars, faSignOutAlt} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {withApollo} from 'react-apollo';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {logout} from '../../utils';
import {withLoadedUser} from '../../login/containers/AuthBase';
import {withTheme} from './HOC/withTheme';

const Div = styled.div`
  display: flex;
  justify-content: space-between;
  width: 250px;
`;

const StyledHeader = styled.header`
  && {
    background: ${({color}) => color};
  }
`;

const Clean = styled.a`
  &&& {
    color: ${({color}) => color};
  }
`;

const Bill = styled.span`
  &&& {
    color: ${({color}) => color};
  }
`;

const LogoutLink = styled(Link)`
  color: ${({color}) => color};
  margin-left: 5px;
  text-decoration: underline;
`;

class Header extends PureComponent {
  render() {
    const {t, toggleMenu, client, theme, currentUser} = this.props;
    const {header} = theme;

    return (
      <StyledHeader color={header.background} className="app-header navbar bottom-bordered">
        <Div>
          <Clean color={header.logo.color.clean} className="navbar-brand" href="/">
            Clean
            <Bill color={header.logo.color.bill} className="logo">
              Bill<sup className="registered-trademark">®</sup>
            </Bill>
          </Clean>
          <button className="navbar-toggler sidebar-toggler d-md-down-none" type="button" onClick={toggleMenu}>
            <FontAwesomeIcon icon={faBars} color={header.menu}/>
          </button>
        </Div>
        <div style={{paddingRight: 10, textAlign: 'right'}}>
          <Link to="/admin/profile">
            <p className="user-name">
              {currentUser.firstName}
              <span className="user-lastname">{' ' + currentUser.lastName}</span>
            </p>
          </Link>
          <p className="log-out">
            <FontAwesomeIcon icon={faSignOutAlt} color="#bfbed4"/>
            <LogoutLink color={header.logout} to={'/login'} onClick={() => logout(client)}>
              {t('logout')}
            </LogoutLink>
          </p>
        </div>
      </StyledHeader>
    );
  }
}

Header.propTypes = {
  t: PropTypes.func.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  theme: PropTypes.shape({
    header: PropTypes.shape({
      background: PropTypes.string.isRequired,
      logout: PropTypes.string.isRequired,
      logo: PropTypes.shape({
        color: PropTypes.shape({
          clean: PropTypes.string.isRequired,
          bill: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default compose(
  withApollo,
  withTranslation('common'),
  withTheme,
  withLoadedUser,
)(Header);
